import { useEffect } from 'react';

const useActiveEventHandler = (ref, eventName, handler) => {
  useEffect(() => {
    const node = ref.current;
    if (node === null || handler === undefined) {
      return;
    }
    node.addEventListener(eventName, handler, {
      passive: false
    });
    return () => {
      node.removeEventListener(eventName, handler);
    };
  }, [ref, eventName, handler]);
};

export { useActiveEventHandler };
//# sourceMappingURL=useActiveEventHandler.js.map
